import React from "react";

class StepThree extends React.Component {
  preferBlockRef = null;

  render() {
    const {
      data,
      currentOrder,
      onSatisfiedChange,
      onPreferredLevelChange,
      onPreferredPeriodChange,
      onSubmit
    } = this.props;

    // Level options rules:
    // 1: [1, 2]
    // 2–4: [prev, current, next]
    // 5: [4, 5, 6, TOEFL, Level 7, Level 8]
    // 6, TOEFL (7), Level 7 (12) or Level 8 (13): [5, 6, TOEFL, Level 7, Level 8]
    // Obs: "Level 7" tem order 12 e "Level 8" tem order 13 no banco (ficam acima do TOEFL, que tem order 7)
    const levelOptions = [];

    if (currentOrder <= 4) {
      if (currentOrder > 1) {
        levelOptions.push({
          order: currentOrder - 1,
          label: `Level ${currentOrder - 1}`
        });
      }
      levelOptions.push({
        order: currentOrder,
        label: `Level ${currentOrder}`
      });
      levelOptions.push({
        order: currentOrder + 1,
        label: currentOrder + 1 === 7 ? "TOEFL" : `Level ${currentOrder + 1}`
      });
    } else if (currentOrder === 5) {
      levelOptions.push({ order: 4, label: "Level 4" });
      levelOptions.push({ order: 5, label: "Level 5" });
      levelOptions.push({ order: 6, label: "Level 6" });
      levelOptions.push({ order: 7, label: "TOEFL" });
      levelOptions.push({ order: 12, label: "Level 7" });
      levelOptions.push({ order: 13, label: "Level 8" });
    } else {
      // currentOrder === 6, 7 (TOEFL), 12 (Level 7) or 13 (Level 8)
      levelOptions.push({ order: 5, label: "Level 5" });
      levelOptions.push({ order: 6, label: "Level 6" });
      levelOptions.push({ order: 7, label: "TOEFL" });
      levelOptions.push({ order: 12, label: "Level 7" });
      levelOptions.push({ order: 13, label: "Level 8" });
    }

    const periodOptions = [
      { value: "MorningLab", label: "Morning Lab" },
      { value: "EveningLab", label: "Evening Lab" },
      { value: "SuperIntensive", label: "Super Intensive" },
      { value: "IntensivePlusLab", label: "Intensive Plus LAB" }
    ];

    // Survey is submitted (answered Yes) or (answered No + filled both)
    const canSubmit =
      data.Satisfied === true ||
      (data.Satisfied === false &&
        data.PreferredLevel !== null &&
        data.PreferredPeriod !== null);

    if (data.Submitted) {
      return (
        <div
          className="multisteps-form__panel js-active"
          data-animation="slideHorz"
        >
          <div className="wizard-forms">
            <div className="inner clearfix">
              <div className="form-content pera-content">
                <div className="step-inner-content">
                  <div className="row" style={{ marginLeft: "0" }}>
                    <span
                      className="step-box-icon"
                      style={{ marginBottom: "4rem" }}
                    >
                      <img
                        src={require("../../assets/img/logo_lumos.png").default}
                        alt=""
                      />
                    </span>
                  </div>

                  <div style={{ textAlign: "center", padding: "3rem 1rem" }}>
                    <i
                      className="fa fa-check-circle"
                      style={{
                        fontSize: "4rem",
                        color: "#28a745",
                        marginBottom: "1.5rem",
                        display: "block"
                      }}
                    />
                    <h2 style={{ marginBottom: "1rem" }}>
                      Thank you for your feedback!
                    </h2>
                    <p style={{ color: "#666", fontSize: "18px" }}>
                      Your survey response has been recorded.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div
        className="multisteps-form__panel js-active"
        data-animation="slideHorz"
      >
        <div className="wizard-forms">
          <div className="inner clearfix">
            <div className="form-content pera-content">
              <div className="step-inner-content">
                {/* Logo */}
                <div className="row" style={{ marginLeft: "0" }}>
                  <span
                    className="step-box-icon"
                    style={{ marginBottom: "4rem" }}
                  >
                    <img
                      src={require("../../assets/img/logo_lumos.png").default}
                      alt=""
                    />
                  </span>
                </div>

                {/* Header */}
                <span className="step-no bottom-line">Survey</span>
                <div className="step-progress float-right">
                  <span>3 of 3 completed</span>
                  <div className="step-progress-bar">
                    <div className="progress">
                      <div className="progress-bar" style={{ width: "100%" }} />
                    </div>
                  </div>
                </div>

                {/* Self-registration success banner */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "1rem",
                    backgroundColor: "#d4edda",
                    border: "1px solid #c3e6cb",
                    borderRadius: "6px",
                    padding: "1.2rem 1.5rem",
                    marginTop: "2rem"
                  }}
                >
                  <i
                    className="fa fa-check-circle"
                    style={{
                      fontSize: "2rem",
                      color: "#28a745",
                      flexShrink: 0,
                      marginTop: "2px"
                    }}
                  />
                  <div>
                    <strong
                      style={{
                        fontSize: "18px",
                        color: "#155724",
                        display: "block",
                        marginBottom: "0.25rem"
                      }}
                    >
                      Self-Registration Successfully Submitted
                    </strong>
                    <span style={{ color: "#155724", fontSize: "15px" }}>
                      Your self-registration has been received and saved in our
                      system. Your selected period, campus, and level are
                      confirmed.
                    </span>
                  </div>
                </div>

                {/* Survey disclaimer */}
                <div
                  style={{
                    backgroundColor: "#fff8e1",
                    border: "1px solid #ffe082",
                    borderRadius: "6px",
                    padding: "1rem 1.5rem",
                    marginTop: "1rem",
                    fontSize: "14px",
                    color: "#5d4e00",
                    lineHeight: "1.6"
                  }}
                >
                  <strong>📋 Optional Survey</strong>
                  <br />
                  The questions below are an{" "}
                  <strong>optional satisfaction survey only</strong>. They do{" "}
                  <strong>not</strong> replace or modify the self-registration
                  you already submitted. Your original answers — period, campus,
                  and level — have already been recorded and are the ones that
                  count. This survey simply helps us understand your preferences
                  for our internal records.
                </div>

                {/* Question */}
                <h2 style={{ marginTop: "1.5rem" }}>
                  Are you satisfied with the information you submitted?
                </h2>
                <p style={{ color: "#555", marginBottom: "1rem" }}>
                  This includes the selected <strong>period</strong>,{" "}
                  <strong>campus</strong>, and <strong>level</strong>.
                </p>

                {/* Yes / No radios */}
                <div
                  className="services-select-option"
                  style={{ marginBottom: "1.5rem" }}
                >
                  <ul>
                    <div onClick={() => onSatisfiedChange(true)}>
                      <li className="bg-white">
                        <label>
                          Yes, I am satisfied
                          <input
                            type="radio"
                            name="survey_satisfied"
                            checked={data.Satisfied === true}
                            onChange={() => onSatisfiedChange(true)}
                          />
                        </label>
                      </li>
                    </div>
                    <div
                      onClick={() => {
                        onSatisfiedChange(false);
                        setTimeout(
                          () =>
                            this.preferBlockRef &&
                            this.preferBlockRef.scrollIntoView({
                              behavior: "smooth"
                            }),
                          150
                        );
                      }}
                    >
                      <li className="bg-white">
                        <label>
                          No, I’d prefer other options
                          <input
                            type="radio"
                            name="survey_satisfied"
                            checked={data.Satisfied === false}
                            onChange={() => onSatisfiedChange(false)}
                          />
                        </label>
                      </li>
                    </div>
                  </ul>
                </div>

                {/* Conditional: preferred level + period */}
                {data.Satisfied === false && (
                  <div
                    ref={(el) => {
                      this.preferBlockRef = el;
                    }}
                  >
                    <h2>What would you prefer?</h2>
                    <div
                      className="row form-inner-area"
                      style={{ marginTop: "1rem" }}
                    >
                      {/* Preferred Level */}
                      <div className="col-md-6">
                        <h4 style={{ marginBottom: "0.75rem", color: "#333" }}>
                          Preferred Level
                        </h4>
                        <div className="services-select-option-survey-level">
                          <ul>
                            {levelOptions.map((lvl) => (
                              <div
                                key={lvl.order}
                                onClick={() =>
                                  onPreferredLevelChange(lvl.order)
                                }
                              >
                                <li className="bg-white">
                                  <label>
                                    {lvl.label}
                                    {lvl.order === currentOrder && (
                                      <span
                                        style={{
                                          marginLeft: "8px",
                                          fontSize: "0.8rem",
                                          backgroundColor: "#f58220",
                                          color: "white",
                                          padding: "2px 6px",
                                          borderRadius: "4px"
                                        }}
                                      >
                                        current
                                      </span>
                                    )}
                                    <input
                                      type="radio"
                                      name="survey_level"
                                      checked={
                                        data.PreferredLevel === lvl.order
                                      }
                                      onChange={() =>
                                        onPreferredLevelChange(lvl.order)
                                      }
                                    />
                                  </label>
                                </li>
                              </div>
                            ))}
                          </ul>
                        </div>
                      </div>

                      {/* Preferred Period */}
                      <div className="col-md-6">
                        <h4 style={{ marginBottom: "0.75rem", color: "#333" }}>
                          Preferred Period
                        </h4>
                        <div className="services-select-option-survey-period">
                          <ul>
                            {periodOptions.map((p) => (
                              <div
                                key={p.value}
                                onClick={() => onPreferredPeriodChange(p.value)}
                              >
                                <li className="bg-white">
                                  <label>
                                    {p.label}
                                    <input
                                      type="radio"
                                      name="survey_period"
                                      checked={data.PreferredPeriod === p.value}
                                      onChange={() =>
                                        onPreferredPeriodChange(p.value)
                                      }
                                    />
                                  </label>
                                </li>
                              </div>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Error */}
                {data.ErrorSubmit && data.ErrorSubmit.length > 0 && (
                  <div
                    className="row form-inner-area"
                    style={{ marginTop: "1rem" }}
                  >
                    <div className="col-md-12">
                      <div className="alert alert-danger" role="alert">
                        {data.ErrorSubmit}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="actions">
            <ul>
              <li className="disable" aria-disabled="true">
                {/* No back button — registration already submitted */}
                <span />
              </li>
              <li>
                <span
                  className={
                    canSubmit && !data.Submitting ? "" : "button-disabled"
                  }
                  title="SUBMIT"
                  onClick={canSubmit && !data.Submitting ? onSubmit : undefined}
                  style={{
                    cursor:
                      canSubmit && !data.Submitting ? "pointer" : "default"
                  }}
                >
                  {data.Submitting ? "Submitting..." : "SUBMIT"}{" "}
                  <i className="fa fa-check" />
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default StepThree;
